<template>
  <j-modal
    :title="title"
    :width="width"
    :visible="visible"
    switchFullscreen
    :maskClosable="maskClosable"
    @ok="handleOk"
    :okButtonProps="{ class:{'jee-hidden': disableSubmit},disabled: okDisabled }"
    @cancel="handleCancel"
    :cancelText="$t('关闭')">
    <template slot="footer">
        <a-button key="back" @click="handleCancel">
          {{ $t('关闭') }}
        </a-button>
      </template>
    <meter-userinfo-form ref="realForm" @ok="submitCallback" :disabled="disableSubmit"></meter-userinfo-form>
  </j-modal>
</template>

<script>

  import MeterUserinfoForm from './MeterUserinfoForm'
  export default {
    name: 'MeterUserinfoModal',
    components: {
      MeterUserinfoForm
    },
    data () {
      return {
        title:'',
        width:1024,
        visible: false,
        disableSubmit: false,
        maskClosable: false,
        okDisabled: false
      }
    },
    methods: {
      add (currSelected) {
        this.visible=true
        this.$nextTick(()=>{
          this.$refs.realForm.add(currSelected);
        })
      },
      edit (record) {
        console.log(record);
        this.visible=true
        this.$nextTick(()=>{
          this.$refs.realForm.edit(record);
        })
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleOk () {
        this.okDisabled = true;
        this.$refs.realForm.submitForm();
        setTimeout(()=>{
          this.okDisabled = false;
        },2000)
      },
      submitCallback(){
        this.$emit('ok');
        this.visible = false;
      },
      handleCancel () {
        this.$refs.realForm.shut();
        this.close()
      }
    }
  }
</script>